import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import {
  Box,
  Card,
  Container,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomUpload from "../../../components/CustomUpload";
import Select from "../../../components/Select/Select";
import api from "../../../redux/actions/api";
import { createNewChat } from "../../../redux/reducers/chatSlice";
import {
  checkedCallInApi,
  checkedInApi,
  clinicReassignAppointment,
  getBillDetailsByPaymentIdWoLoader,
  getBillingListByPetId,
  getBillingsByCustomerId,
  getVitalTrendsByPetId,
  updateAppointmentStatusById,
  updateClinicUserById,
  updateCompleted,
  updateFinalize,
  updateHospitalizationStatus,
} from "../../../redux/reducers/clinicSlice";
import { getMedicalHistoryByPetId } from "../../../redux/reducers/medicalHistorySlice";
import {
  addCoOwnerByPetId,
  getPetBreedsByType,
  getPetDetailsById,
  getPetsCompliantSummary,
  getPetTypes,
  updatePetById,
} from "../../../redux/reducers/petSlice";
import {
  assignTreatmentBundleToPet,
  getAllTreatmentBundlesByPetId,
  getTreatmentBundles,
} from "../../../redux/reducers/planSlice";
import {
  getClinicVetsWoLoader,
  updateAppointmentStatus,
} from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import { radioPaymentTypes } from "../../../util/arrayList";
import { a4PrintConfig } from "../../../util/commonConfig";
import {
  bloodGroups,
  genderList,
  reproductiveStatusFemaleList,
  reproductiveStatusMaleList,
  reproductiveStatusUnknownList,
  temperaments,
  UserPaymentTypeList,
} from "../../../util/dropList";
import {
  getBorderColor,
  getMonthsDifference,
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getTotalEstimatedCost,
  reduceYearsAndMonthsToStartOfMonth,
} from "../../../util/function";
import { superTailsClinicId } from "../../../util/server";
import CreateClinicPet from "../../CommonComponents/CreateClinicPet";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";
import ContentToPrint from "../../CommonScreens/ContentToPrint/ContentToPrint";
import MedicalHistoryView from "../../Hospital/ClinicPetDetails/MedicalHistory/MedicalHistoryView";
import Allergies from "../../Hospital/ClinicPetDetails/PatientWorkbook/Allergies";
import InternalNotes from "../../Hospital/ClinicPetDetails/PatientWorkbook/InternalNotes";
import InternalTags from "../../Hospital/ClinicPetDetails/PatientWorkbook/InternalTags";
import InpatientAdmitPatient from "../AdmitPatient/InpatientAdmitPatient";
import BookAnAppointment from "../BookAppointmentment/BookAnAppointment";
import ReminderDiagnostics from "../Reminder/ReminderDiagnostics";
import ReminderPreventive from "../Reminder/ReminderPreventive";
import ReminderProcedure from "../Reminder/ReminderProcedure";
import CerificatesDownloadModal from "./CerificatesDownloadModal";
import "./CommonClinicPetDetails.css";
import PetRemindersSidebar from "./PetRemindersSidebar";

const vitalTrendTabs = ["Temperature", "Weight"];

const getVitalTrendFieldKey = (tab) => {
  return tab === "Weight" ? "Body Weight" : "Body Temperature";
};

const initCoOwnValues = { name: "", email: "", mobile: "" };
const initCoOwnErrors = { name: false, email: false, mobile: false };
const keysToCheck = [
  "invoiceNumbers",
  "petShopInvoiceNumber",
  "treatmentInvoiceNumber",
];

const requiredFields = [
  "petName",
  "dob",
  "breed",
  // "gender",
  // "reproductiveStatus",
  // "weight",
  "petType",
];
const initSOAValues = {
  visible: false,
  startDate: new Date(),
  endDate: new Date(),
  dateSelected: false,
  endDateErr: false,
};

const CommonClinicPetDetails = ({
  children,
  upcomingVisible,
  setVideoCallEnabled,
  appointment,
  scrollable = true,
  setSelectedTab,
  setInpatientId,
  allergyModOpen,
  setAllergyModOpen,
  selectedTab,
  setScrollable,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const contentToPrint = useRef(null);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [selectPet, setSelectPet] = useState(null);
  const [modalBookVisible, setBookModVisible] = useState(false);
  const [coOwnerModalVisible, setCoOwnerModalVisible] = useState(false);
  const [intrnalTagModVsble, setIntrnalTagModVsble] = useState(false);
  const [intrnalNoteModVsble, setIntrnalNoteModVsble] = useState(false);
  const [admitModVisible, setAdmitModVisible] = useState(false);
  const [vets, setVets] = useState([]);
  const [coOwnDetails, setCoOwnDetails] = useState(initCoOwnValues);
  const [coOwnErrors, setCoOwnErrors] = useState(initCoOwnErrors);
  const [disCofrmModVsble, setDisConfrmModVsble] = useState(false);
  const [createPetModVsble, setCreatePetModVsble] = useState(false);
  const [bundleModVsble, setBundleModVsble] = useState(false);
  const [isAddNewBundle, setAddNewBundle] = useState(false);
  const [selectedBundle, setSelectedBundle] = useState(null);
  const [sendToRecovery, setSendToRecovery] = useState(false);
  const [assignVetModVisible, setAssignVetModVisible] = useState(false);
  const [assignVetvalues, setAssignVetValues] = useState({});
  const [bundleSearchValue, setBundleSearchValue] = useState("");
  const [petModVsble, setPetModVsble] = useState(false);
  const [petValues, setPetValues] = useState({});
  const [errors, setErrors] = useState({});
  const [breedList, setBreedList] = useState([]);
  const [petTypeList, setPetTypeList] = useState([]);
  const [usrModVsble, setUsrModVsble] = useState(false);
  const [usrValues, setUsrValues] = useState({});
  const [usrErrs, setUsrErrs] = useState({});
  const [advancePayVsble, setAdvancePayModVsble] = useState(false);
  const [remModVsble, setRemModVsble] = useState(false);
  const [actTab, setActTab] = useState("preventive");
  const [presFilter, setPresFilter] = useState("Active");
  const [addVsble, setAddVsble] = useState(false);
  const [certModVsble, setCertModVsble] = useState(false);
  const [soaValues, setSOAValues] = useState(initSOAValues);
  const [petApptModVsble, setPetApptModVsble] = useState(false);
  const [customerSOAVsble, setCustomerSOAVsble] = useState(false);
  const [viewTreadsVsble, setViewTreadsVsble] = useState(false);
  const [selectedVitalTab, setSelectedVitalTab] = useState("Temperature");
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const appData = useSelector((state) => state?.pet?.complaintSummary?.data);
  const { petDetails, petAppointments } = useSelector((state) => state?.pet);
  const petBilling = useSelector((state) => state?.clinic?.petAllBilling);
  const {
    details: clinicDetails,
    facilities,
    petBillingList,
    billDetailsWoLoader,
    billDetails,
    cutomerBilling,
    vitalTrends,
  } = useSelector((state) => state?.clinic);
  const { treatmentBundles, petTreatmentBundles } = useSelector(
    (state) => state?.plan,
  );
  const apntId = appointment?.appoinment?.appointmentId;
  const petId = appointment?.appoinment?.petId;
  const userId = appointment?.appoinment?.userId;
  const petData = apntId ? appData?.pet : petDetails;
  const apntDet = appData?.appointment ?? appointment?.appoinment;
  const statusActive =
    typeof petData?.status === "boolean"
      ? petData?.status
      : petData?.status === "Y";
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const role = localStorage.getItem("role");
  const clinicDet = clinicDetails;
  const reqBillDetails =
    billDetails?.appointmentId === apntId ? billDetails : billDetailsWoLoader;

  useEffect(() => {
    if (role === "ROLE_RADIOLOGY" && apntId) {
      getcompliantSummary(apntId);
    }
  }, [role, apntId]);

  useEffect(() => {
    if (selectedTab === "overView") {
      if (vets?.length === 0 || !vets)
        dispatch(getClinicVetsWoLoader("?type=all"));
      if (userId) dispatch(getBillingsByCustomerId(userId));
      // dispatch(getPetBillingByIdAllWoLoader({ petId }));
    }
  }, [selectedTab]);

  useEffect(() => {
    const reqVetList = clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
    setVets(reqVetList);
  }, [clinicVets]);

  useEffect(() => {
    if (
      apntId &&
      apntDet?.appointmentStatus === "finalize" &&
      appData?.paymentId &&
      role !== "ROLE_RADIOLOGY"
    ) {
      dispatch(getBillDetailsByPaymentIdWoLoader(appData?.paymentId));
    }
  }, [appData, apntDet, apntId, role]);

  const getcompliantSummary = (apntId = null) => {
    const reqApntId = apntId ?? apntDet?.appointmentId;
    dispatch(getPetsCompliantSummary(reqApntId));
  };

  const bookAppointment = () => {
    setSelectPet(petData);
    setBookModVisible(true);
  };

  const vitalTrendChartData = useMemo(() => {
    const vitalFieldKey = getVitalTrendFieldKey(selectedVitalTab);

    return (vitalTrends ?? [])
      .map((item) => {
        const record = item?.data?.[0];
        if (!record) return null;

        const rawValue = record?.[vitalFieldKey];
        if (rawValue === undefined || rawValue === null || rawValue === "") {
          return null;
        }

        const value = Number(rawValue);
        if (Number.isNaN(value)) return null;

        return {
          vitalId: item?.vitalId,
          value,
          label: moment(item?.createdDate).format("DD MMM YYYY"),
          dateTime: moment(item?.createdDate).format("DD MMM YYYY, HH:mm"),
          createdDate: item?.createdDate,
        };
      })
      .filter(Boolean)
      .sort(
        (a, b) =>
          new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime(),
      );
  }, [vitalTrends, selectedVitalTab]);

  const vitalTrendTooltipFormatter = useCallback(
    ({ dataPointIndex }) => {
      const item = vitalTrendChartData?.[dataPointIndex];
      if (!item) return "";

      const unit = selectedVitalTab === "Weight" ? "Kg" : "°F";

      return (
        '<div class="apexcharts-tooltip-title" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; background-color: #EBEBEB; color: #000; padding: 8px; margin: 0;">' +
        item.dateTime +
        '<span class="apexcharts-tooltip-marker" style="background-color: #0047AB; margin-left: 5px; width: 12px; height: 12px; border-radius: 2px; display: inline-block;"></span>' +
        "</div>" +
        '<div class="apexcharts-tooltip-series-group" style="order: 1; display: flex; background-color: #fff; padding: 8px;">' +
        '<div class="apexcharts-tooltip-text" style="font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #000;">' +
        '<div class="apexcharts-tooltip-y-group">' +
        '<span class="apexcharts-tooltip-text-y-label">' +
        selectedVitalTab +
        ": </span>" +
        '<span class="apexcharts-tooltip-text-y-value" style="font-weight: 600;">' +
        item.value +
        " " +
        unit +
        "</span>" +
        "</div>" +
        "</div>" +
        "</div>"
      );
    },
    [vitalTrendChartData, selectedVitalTab],
  );

  const vitalTrendChartOptions = useMemo(
    () => ({
      chart: { type: "line", toolbar: { show: false }, fontFamily: "inherit" },
      stroke: {
        width: 2,
        curve: "smooth",
      },
      markers: {
        size: 4,
        colors: ["#fff"],
        strokeColors: "#0047AB",
        strokeWidth: 2,
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: vitalTrendChartData.map((item) => item.dateTime),
        title: {
          text: "Date / Time",
          style: { fontSize: "12px", color: "#666", fontWeight: 500 },
        },
        labels: {
          style: { fontSize: "11px", colors: "#2C2C49", fontWeight: 500 },
          rotate: -35,
          hideOverlappingLabels: true,
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: {
        labels: {
          style: { fontSize: "12px", colors: "#2C2C49" },
          formatter: (val) => val,
        },
        title: {
          text: selectedVitalTab === "Weight" ? "Kg" : "°F",
          style: { fontSize: "12px", color: "#666", fontWeight: 500 },
        },
      },
      grid: {
        strokeDashArray: 4,
        borderColor: "#E9ECEF",
      },
      colors: ["#0047AB"],
      tooltip: {
        custom: vitalTrendTooltipFormatter,
      },
    }),
    [vitalTrendChartData, selectedVitalTab, vitalTrendTooltipFormatter],
  );

  const vitalTrendChartSeries = useMemo(
    () => [
      {
        name: selectedVitalTab,
        data: vitalTrendChartData.map((item) => item.value),
      },
    ],
    [vitalTrendChartData, selectedVitalTab],
  );

  const onViewTrends = () => {
    if (petId) dispatch(getVitalTrendsByPetId(petId));
    setViewTreadsVsble(true);
  };

  const openCoOwnerModal = () => {
    setCoOwnerModalVisible(true);
  };

  const openIntrnalTagModal = () => {
    setIntrnalTagModVsble(true);
  };

  const openIntrnalNotModal = () => {
    setIntrnalNoteModVsble(true);
  };

  const getAllClinicUserList = () => {
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.status === "Y")
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const getOthersByType = (type) => {
    const reqType = type === "Grooming" ? "ROLE_GROOMER" : "ROLE_RADIOLOGY";
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.userRole === reqType)
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const getVetList = () => {
    return clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
  };

  const checkIsVet = (apntVetId = null) => {
    if (!apntVetId) return false;
    return clinicVets?.some((li) =>
      li?.doctorId === apntVetId && li?.userType?.length > 0
        ? li?.userType?.some((ut) => ut?.name === "ROLE_DOCTOR")
        : false,
    );
  };

  const onCloseAssignVetMod = () => {
    setAssignVetModVisible(false);
    setAssignVetValues({});
  };

  const handleCallInApi = (
    vetId = null,
    facilityId = null,
    facilityName = null,
  ) => {
    const data = {
      appointmentId: apntDet?.appointmentId,
      doctorId: vetId ?? apntDet?.doctorId,
      facilityId,
      facilityName,
    };
    dispatch(checkedCallInApi(data)).then((res) => {
      if (res?.payload) {
        onCloseAssignVetMod();
        getcompliantSummary();
      }
    });
  };

  const callButtonApi = () => {
    if (apntDet?.appointmentType === "Virtual") {
      return handleJoinVideoCall();
    }
    if (apntDet?.appointmentStatus === "scheduled") {
      const data = {
        appointmentId: apntDet?.appointmentId,
        doctorId: apntDet?.doctorId,
      };
      dispatch(checkedInApi(data)).then((response) => {
        if (response?.payload) {
          getcompliantSummary();
        }
      });
    } else if (apntDet?.appointmentStatus === "inprogress") {
      if (
        (clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)) ||
        !apntDet?.facilityId
      ) {
        const reqVet =
          clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apntDet?.doctorId)
                    ? apntDet?.doctorId
                    : checkIsVet(profile?.id)
                      ? profile?.id
                      : null),
              );
        setAssignVetValues({
          vet:
            clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
              ? null
              : {
                  name: reqVet?.name ?? apntDet?.doctorName,
                  value: reqVet?.doctorId ?? apntDet?.doctorId,
                  id: reqVet?.doctorId ?? apntDet?.doctorId,
                },
          facility: apntDet?.facilityId
            ? {
                name: apntDet?.facility ?? "",
                value: apntDet?.facilityId,
                id: apntDet?.facilityId,
              }
            : null,
        });
        setAssignVetModVisible(true);
        return;
      } else {
        handleCallInApi(
          checkIsVet(profile?.id) ? profile?.id : apntDet?.doctorId,
          apntDet?.facilityId,
          apntDet?.facility,
        );
      }
    } else if (apntDet?.appointmentStatus === "consultation") {
      dispatch(updateFinalize(apntDet?.appointmentId)).then((response) => {
        if (response?.payload) {
          getcompliantSummary();
        }
      });
    } else {
      dispatch(updateCompleted(apntDet?.appointmentId)).then((response) => {
        if (response?.payload) {
          if (
            profile?.createdBy === superTailsClinicId ||
            profile?.id === superTailsClinicId
          ) {
            dispatch(
              getMedicalHistoryByPetId({
                petId: apntDet?.petId,
                // url: `?type=all&page=1&itemSize=5`,
              }),
            ).then((res2) => {
              if (res2?.payload?.data) {
                setSelectedHistory(res2?.payload?.data?.[0]);
              }
            });
          }
          getcompliantSummary();
        }
      });
    }
  };

  const handleInTransitApi = (
    vetId = null,
    facilityId = null,
    facilityName = null,
  ) => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: apntDet?.appointmentId,
        status: "intransit",
        successMsg: "Patient has been notified!",
        url: `&facilityId=${facilityId}&facilityName=${facilityName}&doctorId=${vetId}`,
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseAssignVetMod();
        getcompliantSummary();
      }
    });
  };

  const callHomeBtnApi = () => {
    if (apntDet?.appointmentType === "Virtual") {
      return handleJoinVideoCall();
    }
    if (apntDet?.appointmentType === "Physical") {
      return callButtonApi();
    }
    let status = "scheduled";
    if (apntDet?.appointmentStatus === "scheduled") {
      if (
        (clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)) ||
        !apntDet?.facilityId
      ) {
        const reqVet =
          clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apntDet?.doctorId)
                    ? apntDet?.doctorId
                    : checkIsVet(profile?.id)
                      ? profile?.id
                      : null),
              );
        setAssignVetValues({
          vet:
            clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
              ? null
              : {
                  name: reqVet?.name ?? apntDet?.doctorName,
                  value: reqVet?.doctorId ?? apntDet?.doctorId,
                  id: reqVet?.doctorId ?? apntDet?.doctorId,
                },
          facility: apntDet?.facilityId
            ? {
                name: apntDet?.facility ?? "",
                value: apntDet?.facilityId,
                id: apntDet?.facilityId,
              }
            : null,
        });
        setAssignVetModVisible(true);
        return;
      } else {
        handleInTransitApi(
          checkIsVet(profile?.id) ? profile?.id : apntDet?.doctorId,
          apntDet?.facilityId,
          apntDet?.facility,
        );
      }
      return;
    }
    if (apntDet?.appointmentStatus === "intransit") {
      status = "consultation";
    }
    if (apntDet?.appointmentStatus === "consultation") {
      status = "finalize";
    }
    if (apntDet?.appointmentStatus === "finalize") {
      status = "completed";
    }
    dispatch(
      updateAppointmentStatusById({
        appointmentId: apntDet?.appointmentId,
        status,
        successMsg:
          status === "intransit"
            ? "Patient has been notified!"
            : "Status updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        if (
          (status === "completed" &&
            profile?.createdBy === superTailsClinicId) ||
          profile?.id === superTailsClinicId
        ) {
          dispatch(
            getMedicalHistoryByPetId({
              petId: apntDet?.petId,
              // url: `?type=all&page=1&itemSize=5`,
            }),
          ).then((res2) => {
            if (res2?.payload?.data) {
              setSelectedHistory(res2?.payload?.data?.[0]);
            }
          });
        }
        if (clinicDetails?.id !== apntDet?.doctorId) {
          getcompliantSummary(apntDet?.appointmentId);
        }
      }
    });
  };

  const handleJoinVideoCall = () => {
    setVideoCallEnabled(true);
    if (navigator.mediaDevices.getUserMedia !== null) {
      var options = {
        video: true,
        audio: true,
      };
      navigator.getUserMedia(options, function (e) {
        console.log("background error : " + e.name);
      });
    }
    if (apntDet?.appointmentStatus?.toLowerCase() === "scheduled") {
      dispatch(
        updateAppointmentStatus({
          appId: apntDet?.appointmentId,
          status: "inprogress",
        }),
      );
    }
  };

  const onCloseAdmitModal = (val) => {
    if (val === "Api Success") {
      if (sendToRecovery) {
        dispatch(
          updateAppointmentStatusById({
            appointmentId: apntDet?.appointmentId,
            status: "recovery",
            successMsg: "Status updated successfully!",
          }),
        )?.then((res) => {
          if (res?.payload) getcompliantSummary(apntDet?.appointmentId);
        });
      } else {
        getcompliantSummary(apntDet?.appointmentId);
      }
    }
    setAdmitModVisible(false);
    setSendToRecovery(false);
  };

  const handleDischarge = () => {
    setDisConfrmModVsble(true);
  };

  const handleCoOwnModClose = () => {
    setCoOwnDetails(initCoOwnValues);
    setCoOwnErrors(initCoOwnErrors);
    setCoOwnerModalVisible(false);
  };

  const handleCoOwnChange = (name, value) => {
    setCoOwnDetails({ ...coOwnDetails, [name]: value });
    setCoOwnErrors({ ...coOwnErrors, [name]: value !== "" ? false : true });
  };

  const handleValidation = () => {
    let errs = {};
    Object.keys(coOwnDetails).forEach((det) => {
      if (coOwnDetails?.[det] === "") {
        errs = { ...errs, [det]: true };
      }
    });
    setCoOwnErrors({ ...coOwnErrors, ...errs });
    return Object.keys(errs).length > 0 ? false : true;
  };

  const handleSaveCoOwner = async () => {
    const validated = handleValidation();
    if (!validated) return;
    const data = {
      name: coOwnDetails?.name,
      email: coOwnDetails?.email,
      mobile: coOwnDetails?.mobile,
    };
    dispatch(addCoOwnerByPetId({ petId: petData?.petId, data })).then((res) => {
      if (res?.payload) {
        handleCoOwnModClose();
        if (apntId) {
          getcompliantSummary(apntDet?.appointmentId);
        } else {
          dispatch(getPetDetailsById(petId));
        }
      }
    });
  };

  const handleCloseDisCnfrm = () => {
    setDisConfrmModVsble(false);
  };

  const handleConfirmDischarge = () => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: apntDet?.appointmentId,
        status: "finalize",
        successMsg: "Status updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        handleCloseDisCnfrm();
        getcompliantSummary(apntDet?.appointmentId);
      }
    });
  };

  const onCloseCreateMod = (e) => {
    if (e === "petCreated") {
      if (apntId) {
        getcompliantSummary(apntDet?.appointmentId);
      } else {
        dispatch(getPetDetailsById(petId));
      }
    }
    setCreatePetModVsble(false);
  };

  const handleChat = () => {
    dispatch(
      createNewChat(apntId ? appData?.pet?.userId : petDetails?.userId),
    ).then((res) => {
      if (res?.payload) {
        navigate("/chat", { state: { chatId: res?.payload?.chatId } });
      }
    });
  };

  const getAllOutstandingBlance = () => {
    return cutomerBilling?.data?.length > 0
      ? cutomerBilling?.data
          // ?.filter((li) => (li?.status ?? "")?.toLowerCase() !== "paid")
          ?.reduce(
            (acc, obj) => acc + Number(obj?.balanceDue ?? 0),
            //  obj?.balanceDue
            0,
          )
      : 0;
  };

  const handleBundleSelect = () => {
    dispatch(getAllTreatmentBundlesByPetId(petId ?? petDetails?.petId));
    setBundleModVsble(true);
  };

  const handleBundleclose = () => {
    setSelectedBundle(null);
    setBundleModVsble(false);
    setAddNewBundle(false);
    setBundleSearchValue("");
  };

  const handleAddBundle = () => {
    dispatch(getTreatmentBundles());
    setAddNewBundle(true);
  };

  const handleAssign = () => {
    if (
      (selectedBundle?.treatmentId ?? selectedBundle?.bundleId) &&
      (petId ?? petDetails?.petId)
    ) {
      dispatch(
        assignTreatmentBundleToPet({
          treatmentId: selectedBundle?.treatmentId ?? selectedBundle?.bundleId,
          petId: petId ?? petDetails?.petId,
        }),
      ).then((res) => {
        if (res?.payload) {
          handleBundleclose();
        }
      });
    }
  };

  const handleEditPet = () => {
    const reqObj = {
      petId: petData?.petId,
      ageType: "Month",
      dob: getMonthsDifference(petData?.dob),
      petType: null,
      breed: null,
      petName: petData?.petName,
      color: petData?.color,
      gender: petData?.gender,
      reproductiveStatus: petData?.reproductiveStatus,
      weight: petData?.weight,
      rfid: petData?.rfid,
      bloodGroup:
        petData?.bloodGroup?.length > 0
          ? { name: petData?.bloodGroup, value: petData?.bloodGroup }
          : null,
      temperament:
        petData?.temperament?.length > 0
          ? { name: petData?.temperament, value: petData?.temperament }
          : null,
      image: { file: null, previewUrl: petData?.petImage ?? null },
    };
    dispatch(getPetTypes()).then((res) => {
      if (res?.payload) {
        const reqList = res?.payload?.map((sp) => ({
          name: sp?.speciesName,
          value: sp?.speciesName,
          id: sp?.speciesId,
        }));
        reqObj.petType =
          reqList?.find(
            (sp) =>
              (sp?.name ?? "")?.toLowerCase() ===
              (petData?.petType ?? "")?.toLowerCase(),
          ) ?? null;
        setPetTypeList(reqList);
        if (reqObj?.petType?.id) {
          dispatch(getPetBreedsByType(reqObj?.petType?.id)).then((res2) => {
            if (res2?.payload) {
              const reqList = res2?.payload?.map((bd) => ({
                ...bd,
                name: bd?.breedName,
                value: bd?.breedName,
              }));
              reqObj.breed = reqList?.find(
                (bd) =>
                  bd?.value?.toLowerCase() === petData?.breed?.toLowerCase(),
              );
              setBreedList(reqList);
            }
          });
        }
      }
    });

    setPetValues(reqObj);
    setPetModVsble(true);
  };

  const petModClose = () => {
    setPetModVsble(false);
    setPetValues({});
    setErrors({});
  };

  const handleEditUser = () => {
    setUsrValues({
      userName: petData?.userName,
      userMobile: petData?.userMobile,
      address: petData?.address,
      email: petData?.userEmail,
      petId: petData?.petId,
      secondaryMobile: petData?.secondaryMobile ?? "",
    });
    setUsrModVsble(true);
  };

  const usrModClose = () => {
    setUsrModVsble(false);
    setUsrValues({});
    setUsrErrs({});
  };

  const handleValueChange = (value, name) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    const valObj = { ...usrValues, [name]: value };
    if (name === "paymentType") {
      valObj.paymentMode = null;
    }
    setUsrValues(valObj);
    const errObj = {
      ...usrErrs,
      [name]:
        reqValue?.length > 0
          ? ""
          : name === "email"
            ? ""
            : "This field is required",
    };

    if (name === "advanceAmount") {
      if (Number(value) <= 0) {
        errObj.advanceAmount = "Amount should be greater than 0";
      } else if (
        Number(value) > Number(petData?.advanceAmount ?? 0) &&
        usrValues?.paymentType === "Refund"
      ) {
        errObj.advanceAmount = "Insufficient credit balance";
      } else {
        errObj.advanceAmount = "";
      }
    }
    setUsrErrs(errObj);
  };

  const onUploadFile = (e) => {
    const reader = new FileReader();
    const file = e?.target?.files[0];
    reader.onloadend = () => {
      setPetValues({
        ...petValues,
        image: { file: e.target.files[0], previewUrl: reader.result },
      });
    };
    reader.readAsDataURL(file);
  };

  const handlePetValueChange = (value, name) => {
    const reqValue =
      typeof value === "object" ? value?.value?.toString() : value;
    const reqObj = { ...petValues, [name]: value };
    if (name === "petType") {
      reqObj.breed = null;
      dispatch(getPetBreedsByType(value?.id)).then((res) => {
        if (res?.payload) {
          const reqList = res?.payload?.map((bd) => ({
            ...bd,
            name: bd?.breedName,
            value: bd?.breedName,
          }));
          setBreedList(reqList);
        }
      });
    }
    setPetValues(reqObj);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]:
        reqValue?.length > 0
          ? ""
          : requiredFields?.includes(name)
            ? "This field is required"
            : "",
    }));
  };

  const validateFields = () => {
    let errObj = {};
    requiredFields?.forEach((key) => {
      const reqValue =
        typeof petValues?.[key] === "object"
          ? petValues?.[key]?.value
          : petValues?.[key];
      if (reqValue?.length === 0 || !reqValue) {
        errObj = { ...errObj, [key]: "This field is required" };
      }
    });
    setErrors({ ...errors, ...errObj });
    return Object.keys(errObj).length > 0;
  };

  const updatePet = () => {
    if (validateFields()) return;
    const form = new FormData();
    if (petData?.ownershipType) {
      form.append("ownershipType", petData?.ownershipType);
    }
    form.append("petName", petValues?.petName);
    form.append("petType", petValues?.petType?.value);
    form.append("breed", petValues?.breed?.value);
    form.append("weight", petValues?.weight);
    form.append("reproductiveStatus", petValues?.reproductiveStatus);
    form.append("gender", petValues?.gender);
    form.append(
      "dob",
      reduceYearsAndMonthsToStartOfMonth({
        years: petValues?.ageType === "Year" ? Number(petValues?.dob) : 0,
        months: petValues?.ageType === "Month" ? Number(petValues?.dob) : 0,
      }),
    );
    form.append("color", petValues?.color);
    if (petValues?.image?.file) form.append("petImage", petValues?.image?.file);
    if (petValues?.rfid?.length > 0) form.append("rfid", petValues?.rfid);
    if (petValues?.bloodGroup?.value?.length > 0)
      form.append("bloodGroup", petValues?.bloodGroup?.value);
    if (petValues?.temperament?.value?.length > 0)
      form.append("temperament", petValues?.temperament?.value);
    dispatch(updatePetById({ petId: petValues?.petId, form })).then((res) => {
      if (res?.payload) {
        if (apntId) {
          getcompliantSummary(apntId);
        } else {
          dispatch(
            getPetDetailsById(petData?.petId ?? petId ?? petValues?.petId),
          );
        }
        petModClose();
      }
    });
  };

  const updateUser = () => {
    if (
      usrValues?.userName?.length === 0 ||
      !usrValues?.userName ||
      usrValues?.userMobile?.length === 0 ||
      !usrValues?.userMobile ||
      !petData?.userId
    ) {
      let errs = { ...usrErrs };
      if (usrValues?.userName?.length === 0 || !usrValues?.userName) {
        errs = { ...errs, userName: "This field is required" };
      }
      if (usrValues?.userMobile?.length === 0 || !usrValues?.userMobile) {
        errs = { ...errs, userMobile: "This field is required" };
      }
      setUsrErrs(errs);
      return;
    }
    const form = new FormData();
    form.append("userName", usrValues?.userName);
    form.append("userMobile", usrValues?.userMobile);
    form.append("advanceAmount", 0);
    if (usrValues?.email?.length > 0) {
      form.append("email", usrValues?.email ?? "");
    }
    // if (usrValues?.address?.length > 0) {
    form.append("address", usrValues?.address ?? "");
    // }
    // if (usrValues?.secondaryMobile?.length > 0) {
    form.append("secondaryMobile", usrValues?.secondaryMobile ?? "");
    // }
    dispatch(updateClinicUserById({ userId: petData?.userId, form })).then(
      (res) => {
        if (res?.payload) {
          if (apntId) {
            getcompliantSummary(apntId);
          } else {
            dispatch(
              getPetDetailsById(petData?.petId ?? petId ?? usrValues?.petId),
            );
          }
          usrModClose();
        }
      },
    );
  };

  const handleCollectAdvance = () => {
    setUsrValues({
      paymentType: radioPaymentTypes?.[0]?.value,
      userName: petData?.userName,
      userMobile: petData?.userMobile,
      email: petData?.userEmail,
      petId: petData?.petId,
      paymentMode: UserPaymentTypeList?.[0],
    });
    setAdvancePayModVsble(true);
  };

  const handleClosePayMod = () => {
    setAdvancePayModVsble(false);
    setUsrValues({});
    setUsrErrs({});
  };

  const handlePay = () => {
    if (
      usrValues?.advanceAmount?.length === 0 ||
      !usrValues?.advanceAmount ||
      !usrValues?.paymentMode ||
      (usrValues?.paymentType === "Refund" &&
        Number(usrValues?.advanceAmount) >
          Number(petData?.advanceAmount ?? 0)) ||
      Number(usrValues?.advanceAmount) <= 0
    ) {
      const errs = {};
      if (!usrValues?.paymentMode) errs.paymentMode = "This field is required";
      if (usrValues?.advanceAmount?.length === 0 || !usrValues?.advanceAmount) {
        errs.advanceAmount = "This field is required";
      } else if (usrValues?.advanceAmount <= 0) {
        errs.advanceAmount = "Amount should be greater than 0";
      } else if (
        usrValues?.paymentType === "Refund" &&
        Number(usrValues?.advanceAmount) > Number(petData?.advanceAmount ?? 0)
      ) {
        errs.advanceAmount = "Insufficient credit balance";
      } else {
        errs.advanceAmount = "";
      }
      setUsrErrs(errs);
      if (Object.keys(errs)?.length > 0) return;
    }
    const form = new FormData();
    form.append("userName", usrValues?.userName);
    form.append("userMobile", usrValues?.userMobile);
    if (
      usrValues?.paymentType === "Collect" &&
      petData?.petName &&
      petData?.petId
    ) {
      form.append("petName", petData?.petName);
      form.append("petId", petData?.petId);
    }
    if (usrValues?.email?.length > 0) {
      form.append("email", usrValues?.email);
    }
    if (usrValues?.address?.length > 0) {
      form.append("address", usrValues?.address);
    }
    if (usrValues?.secondaryMobile?.length > 0) {
      form.append("secondaryMobile", usrValues?.secondaryMobile);
    }
    form.append("paymentType", usrValues?.paymentType);
    form.append(
      "advanceAmount",
      Number(
        `${usrValues?.paymentType === "Collect" ? "+" : "-"}${
          usrValues?.advanceAmount
        }`,
      ),
    );
    form.append("paymentMode", usrValues?.paymentMode?.value);
    dispatch(
      updateClinicUserById({
        userId: petData?.userId,
        form,
        successMsg: "Payment updated successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        if (apntId) {
          getcompliantSummary(apntId);
        } else {
          dispatch(
            getPetDetailsById(petData?.petId ?? petId ?? usrValues?.petId),
          );
        }
        handleClosePayMod();
      }
    });
  };

  const handleClickPet = (pet) => {
    if (pet?.appointmentId) {
      dispatch(getPetsCompliantSummary(pet?.appointmentId));
    } else if (pet?.petId) {
      dispatch(getPetDetailsById(pet?.petId));
    }
    return navigate("/clinic-pet-details", {
      state: {
        appointment: {
          appoinment: {
            appointmentId: pet?.appointmentId ?? null,
            petId: pet?.petId,
            userId: pet?.userId,
          },
        },
        inpatientId: pet?.inpaitentId,
      },
    });
  };

  const handleUploadComplete = async (url, apntId) => {
    await api({ contentType: true, auth: true })
      .get(`/appointment/${apntId}`)
      .then(async (getRes) => {
        if (getRes?.status === 200 || getRes?.status === 201) {
          if (getRes?.data?.data) {
            const reqObj = {
              appointment: {
                ...getRes?.data?.data,
                // caseSummary: url
              },
            };
            try {
              // await superTailsApi.post("/appointment-completed", reqObj);
              setSelectedHistory(null);
            } catch (supErr) {
              console.log("SuperTail Api Error", supErr);
            }
          }
        }
      });
  };

  const onCloseRemMod = () => {
    setRemModVsble(false);
  };

  const onClickAdd = () => {
    setAddVsble(true);
  };

  const onChangeTab = (tab) => {
    setActTab(tab);
    setAddVsble(false);
  };

  const onCloseCertMod = () => {
    setCertModVsble(false);
  };

  const onAssignVetChange = (name, value, errName) => {
    setAssignVetValues({
      ...assignVetvalues,
      [name]: value,
      [errName]: value?.value ? false : true,
    });
  };

  const getFacilitiesByType = (type) => {
    const reqType =
      apntDet?.appointmentType === "Home"
        ? "HomeKit"
        : type === "Surgery"
          ? "OperationTheatre"
          : type === "Consultation" ||
              type === "Lab Tests" ||
              type === "Radiology Tests" ||
              type === "Others"
            ? "ConsultationRoom"
            : "BathBays";
    const reqVetList =
      facilities
        ?.filter((fl) => fl?.type?.toLowerCase() !== "devices")
        // ?.filter((fl) => fl?.type === reqType)
        ?.map((fl) => {
          return { name: fl?.name, value: fl?.facilityId, id: fl?.facilityId };
        }) ?? [];
    return reqVetList;
  };

  const onAssignVet = () => {
    if (!assignVetvalues?.vet?.value || !assignVetvalues?.facility?.value) {
      return setAssignVetValues({
        ...assignVetvalues,
        error: !assignVetvalues?.vet?.value,
        facilityErr: !assignVetvalues?.facility?.value,
      });
    }
    if (apntDet?.inpatient) {
      updateAppointmentStatusByAppointment({
        status: "insurgery",
        successMsg: "Status updated successfully!",
        isReassign: true,
        facilityId: assignVetvalues?.facility?.value,
        facilityName: assignVetvalues?.facility?.name,
        doctorId: assignVetvalues?.vet?.value,
      });
      return;
    }
    if (apntDet?.appointmentType === "Home") {
      handleInTransitApi(
        assignVetvalues?.vet?.value,
        assignVetvalues?.facility?.value,
        assignVetvalues?.facility?.name,
      );
    } else {
      handleCallInApi(
        assignVetvalues?.vet?.value,
        assignVetvalues?.facility?.value,
        assignVetvalues?.facility?.name,
      );
    }
  };

  const updateAppointmentStatusByAppointment = ({
    status,
    isReassign = false,
    successMsg = "Status updated successfully!",
    facilityId = null,
    facilityName = null,
    doctorId = null,
  }) => {
    dispatch(
      updateAppointmentStatusById({
        appointmentId: apntDet?.appointmentId,
        status,
        successMsg,
      }),
    ).then((res) => {
      if (res?.payload) {
        if (isReassign) {
          const reAssignValues = { facilityId, facilityName, doctorId };
          dispatch(
            clinicReassignAppointment({
              appointmentId: apntDet?.appointmentId,
              data: reAssignValues,
            }),
          )?.then((apiRes) => {
            if (apiRes?.payload) {
              onCloseAssignVetMod();
              getcompliantSummary();
              return;
            }
          });
        } else {
          getcompliantSummary();
        }
      }
    });
  };

  const onClickInpatientBtn = () => {
    if (apntDet?.appointmentStatus === "scheduled") {
      if (
        (clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)) ||
        !apntDet?.facilityId
      ) {
        const reqVet =
          clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apntDet?.doctorId)
                    ? apntDet?.doctorId
                    : checkIsVet(profile?.id)
                      ? profile?.id
                      : null),
              );
        setAssignVetValues({
          vet:
            clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
              ? null
              : {
                  name: reqVet?.name ?? apntDet?.doctorName,
                  value: reqVet?.doctorId ?? apntDet?.doctorId,
                  id: reqVet?.doctorId ?? apntDet?.doctorId,
                },
          facility: apntDet?.facilityId
            ? {
                name: apntDet?.facility ?? "",
                value: apntDet?.facilityId,
                id: apntDet?.facilityId,
              }
            : null,
        });
        setAssignVetModVisible(true);
        return;
      } else {
        const reqVet =
          clinicDetails?.id === apntDet?.doctorId && !checkIsVet(profile?.id)
            ? null
            : clinicVets?.find(
                (vl) =>
                  vl?.doctorId ===
                  (checkIsVet(apntDet?.doctorId)
                    ? apntDet?.doctorId
                    : checkIsVet(profile?.id)
                      ? profile?.id
                      : null),
              );
        updateAppointmentStatusByAppointment({
          status: "insurgery",
          successMsg: "Status updated successfully!",
          isReassign: true,
          facilityId: apntDet?.facilityId,
          facilityName: apntDet?.facility,
          doctorId: reqVet?.doctorId ?? apntDet?.doctorId,
        });
      }
    }
    if (apntDet?.appointmentStatus?.toLowerCase() === "insurgery") {
      setSendToRecovery(true);
      setAdmitModVisible(true);
    }
    if (
      apntDet?.appointmentStatus?.toLowerCase() === "recovery" &&
      !appData?.inpatient?.hospitalization
    ) {
      setSendToRecovery(false);
      setAdmitModVisible(true);
    }
    if (
      apntDet?.appointmentStatus?.toLowerCase() === "recovery" &&
      appData?.inpatient?.hospitalization
    ) {
      dispatch(
        updateHospitalizationStatus({
          patientId: appData?.inpatient?.patientId,
          status: false,
        }),
      ).then((res) => {
        if (res?.payload) {
          dispatch(
            updateAppointmentStatusById({
              appointmentId: apntDet?.appointmentId,
              status: "scheduled",
              successMsg: "Status updated successfully!",
            }),
          ).then((res2) => {
            if (res2?.payload) {
              getcompliantSummary();
            }
          });
        }
      });
    }
  };

  const isCheckoutDisabled =
    apntDet?.appointmentStatus === "finalize" &&
    ((clinicDetails?.billingMode ?? "")?.toLowerCase() === "separate"
      ? apntDet?.checkOut !== "Y" ||
        ((getPharmacyRecordBasedType(reqBillDetails?.paymentDetails)?.length >
          0 ||
          Number(reqBillDetails?.pharmacyAmtPaid ?? 0) > 0) &&
          apntDet?.pharmacyCheckout !== "Y") ||
        ((getPetShopRecordBasedType(reqBillDetails?.paymentDetails)?.length >
          0 ||
          Number(reqBillDetails?.petShopAmtPaid ?? 0) > 0) &&
          apntDet?.petShopCheckout !== "Y")
      : apntDet?.checkOut !== "Y");

  const onClickSOA = () => {
    setSOAValues({ ...soaValues, visible: true });
  };

  const onCloseSOAMod = () => {
    setSOAValues(initSOAValues);
  };

  const onChangeSOAValue = (name, value) => {
    const reqObj = { ...soaValues, [name]: value };
    setSOAValues(reqObj);
  };

  const onClickProceed = () => {
    const data = {
      page: 1,
      itemSize: 100,
      startDate: moment(new Date(soaValues?.startDate)).format("YYYY-MM-DD"),
      endDate: moment(new Date(soaValues?.endDate)).format("YYYY-MM-DD"),
    };
    dispatch(getBillingListByPetId({ petId: petData?.petId, data }));
    setSOAValues({ ...soaValues, dateSelected: true });
  };

  const handlePrint = useReactToPrint({
    content: () => contentToPrint?.current,
    documentTitle: `SOA_${Date.now()}`,
    removeAfterPrint: true,
    pageStyle: a4PrintConfig,
  });

  const getPaymentCollections = () => {
    return (petBillingList?.data ?? [])?.flatMap(
      (li) => li?.paymentCollections ?? [],
    );
  };

  const getDepositSummaryList = () => {
    return (petBillingList?.data ?? [])?.flatMap(
      (li) => li?.depositCollections ?? [],
    );
  };

  const getAllPaymentIds = () => {
    return (petBillingList?.data ?? [])?.map((li) => li?.paymentId);
  };

  const getSOAList = () => {
    const reqList = (petBillingList?.data ?? [])
      ?.filter((li) => {
        const isApnt = li?.appointmentId;
        const isPos = li?.type === "Pharmacy" || li?.type === "Pet Shop";
        const isLength = (li?.paymentDetails ?? [])?.length > 0;
        return (isApnt || isPos) && isLength;
      })
      ?.flatMap((item) => {
        const matched = keysToCheck
          ?.map((key) => ({ key, value: item?.[key] }))
          ?.find((inv) => inv?.value?.length > 0);
        const comTotal =
          (item?.totalAmt ?? 0) +
          (item?.pharmacyTotalAmt ?? 0) +
          (item?.petShopTotalAmt ?? 0);
        const main = {
          type: "INVOICE",
          itemDate: item?.createdDate,
          paymentId: item?.paymentId,
          itemType: matched?.value?.includes("ESTP")
            ? "Proforma Invoice"
            : "Invoice",
          refNo: matched?.value ?? "",
          source: "",
          paymentMode: "",
          debit: comTotal,
          credit: 0,
        };
        const collections = (item.paymentCollections || [])
          ?.filter((li) => getAllPaymentIds()?.includes(li?.paymentId))
          ?.map((p) => ({
            type: "PAYMENT",
            itemDate: p?.receiptDate,
            collectionId: p?.collectionId,
            refNo: p?.receiptNo ?? p?.invoiceNo ?? "",
            source: p?.source,
            debit: 0,
            credit: p?.amountPaid,
          }));
        const deposits = (item.depositCollections || [])?.map((d) => ({
          type: "DEPOSIT",
          itemDate: d?.receiptDate,
          collectionId: d?.collectionId,
          refNo: d?.receiptNo ?? d?.invoiceNo ?? "",
          source: d?.source,
          debit: 0,
          credit: d?.amountPaid,
        }));
        return [
          main,
          ...collections,
          //  ...deposits
        ];
      });
    const sortedList = reqList?.sort((a, b) => {
      const aDate = new Date(a?.itemDate);
      const bDate = new Date(b?.itemDate);
      return aDate - bDate;
    });
    let runningBalance = 0;
    const finalList = sortedList?.map((li, i) => {
      runningBalance += (li?.credit || 0) - (li?.debit || 0);
      return { ...li, balanceDue: runningBalance };
    });
    return finalList;
  };

  const soaTotals = (getSOAList() ?? [])?.reduce(
    (acc, item) => {
      acc.totalDebit += item?.debit || 0;
      acc.totalCredit += item?.credit || 0;
      return acc;
    },
    { totalDebit: 0, totalCredit: 0 },
  );

  const getReqAppointments = () => {
    return (petAppointments ?? [])?.filter(
      (apnt) => apnt?.appointmentId !== apntId,
    );
  };

  const onClickAppointment = (apnt) => {
    if (apnt?.appointmentId) {
      dispatch(getPetsCompliantSummary(apnt?.appointmentId));
    } else if (petId) {
      dispatch(getPetDetailsById(petId));
    }
    navigate(`/clinic-pet-details`, {
      state: {
        appointment: {
          appoinment: {
            appointmentId: apnt?.appointmentId,
            petId,
            userId,
          },
        },
        selectedTab: "patientWorkbook",
      },
    });
    setPetApptModVsble(false);
  };

  const onViewCustomerSOA = () => {
    setCustomerSOAVsble(true);
  };

  const getCustomerDueSOA = () => {
    return cutomerBilling?.data?.filter(
      (li) => Number(li?.balanceDue ?? 0) > 0,
    );
  };

  return (
    <>
      <Grid container className="back-white ph20">
        <Grid
          item
          xs={12}
          sm={12}
          md={2.5}
          lg={2.5}
          xl={2.5}
          className="back-white border-rt"
        >
          <div className="scroll-90vh">
            <Container maxWidth="xl" className="ph10 mt15">
              <div className="shadow-card br8 pt10 pb10 pr15 pl15">
                <Typography className="flex-end mb10">
                  <Typography className="fs11 bg-blue-100 clr-blue txt-semi-bold br20 d-inline-block pt3 pb3 pl10 pr10 mr10">
                    {petData?.petType}
                  </Typography>
                </Typography>
                <div className="display-flex just-start ali-start gap4">
                  {petData?.petImage ? (
                    <img src={petData?.petImage} alt="" className="img40" />
                  ) : (
                    <div className="flex-center imghw40 br50Per gray-back">
                      <Typography className="font-bold fs30 white-color capitalize">
                        {petData?.petName?.[0]}
                      </Typography>
                    </div>
                  )}
                  <div className="flex-column ml10">
                    <div className="flex-row">
                      <div className="flex-center">
                        <Custom3dotString
                          str={petData?.petName}
                          className="font-bold fs14"
                        />

                        <Typography
                          className={`ml5 txt-semi-bold fs14 capitalize ${
                            petData?.gender === "male"
                              ? "card-blue-color"
                              : "card-rose-color"
                          }`}
                        >
                          {`(${petData?.gender})`}
                        </Typography>
                      </div>
                    </div>
                    <Typography className="txt-regular fs11">
                      {petData?.breed} -{" "}
                      {(() => {
                        const dob = petData?.dob ?? location?.state?.pet?.dob;
                        const years = moment().diff(moment(dob), "years");
                        if (years > 0) return `${years} yrs`;
                        const months = moment().diff(moment(dob), "months");
                        if (months > 0) return `${months} months`;
                        const days = moment().diff(moment(dob), "days");
                        return `${days} days`;
                      })()}{" "}
                      - {petData?.weight} KG
                    </Typography>
                    <Typography className="txt-regular fs11">
                      Colour: {petData?.color ?? ""}
                    </Typography>
                  </div>
                </div>

                <p className="bottomHr mv10" />

                <div>
                  <div className="flex-row-between-align-center mb3">
                    <div className="fs11 txt-semi-bold clr-muted">CUSTOMER</div>
                    <div
                      className="fs11 txt-semi-bold clr-muted cursor"
                      onClick={handleEditUser}
                    >
                      Edit
                    </div>
                  </div>

                  <Typography className="mb3 font-medium clr-dark-gray fs11">
                    {petData?.userName}
                  </Typography>
                  <Typography className="mb3 font-medium clr-dark-gray fs11">
                    {petData?.userEmail} · {petData?.userMobile ?? ""}
                  </Typography>
                  {petData?.secondaryMobile?.length > 0 ? (
                    <Typography className="mb3 font-medium clr-dark-gray fs11">
                      {petData?.secondaryMobile}
                    </Typography>
                  ) : null}
                  <div className="flex-row-ali-cen">
                    <Typography className="font-medium clr-dark-gray fs11">
                      App status:{" "}
                    </Typography>
                    <Typography className="ml10 fs10 bg-blue-100 clr-blue txt-regular br20 pt3 pb3 pl10 pr10">
                      {(apntId ? appData?.installed : petDetails?.intsalled)
                        ? "Installed"
                        : "Not Installed"}
                    </Typography>
                  </div>
                </div>
                <p className="bottomHr mv10" />
                {petData?.coOwners?.length > 0 &&
                  petData?.coOwners?.slice(0, 1)?.map((own, i) => (
                    <div className="">
                      <div className="d-flex align-items-center justify-content-between gap-2">
                        <p className="mb3 fs11 txt-semi-bold clr-muted">
                          CO-CUSTOMER
                        </p>
                        {petData?.coOwners?.length > 0 ? null : (
                          <Typography
                            className="fs20 font-medium cursor"
                            onClick={openCoOwnerModal}
                          >
                            {" "}
                            +
                          </Typography>
                        )}
                      </div>

                      <Typography className="mb3 font-medium clr-dark-gray fs11">
                        <Custom3dotString
                          str={own?.name}
                          className="font-medium clr-dark-gray fs11"
                          length={15}
                        />
                      </Typography>
                      <Typography className="font-medium clr-dark-gray fs11">
                        {own?.email} · {own?.mobile}
                      </Typography>
                    </div>
                  ))}
              </div>

              <div className="flex-row-ali-cen mv10">
                <div>
                  <CustomButton
                    text="Chat"
                    leftIcon
                    startIcon={<ChatOutlinedIcon />}
                    onClick={handleChat}
                  />
                </div>
                {(apntDet?.appointmentStatus === "finalize" ||
                  !apntDet?.inpatient) &&
                  apntId &&
                  (apntDet?.appointmentStatus === "scheduled" ||
                  apntDet?.appointmentStatus === "inprogress" ||
                  // apntDet?.appointmentStatus === "consultation" ||
                  apntDet?.appointmentStatus === "finalize" ||
                  apntDet?.appointmentStatus === "intransit" ? (
                    //  ||
                    // apntDet?.appointmentType === "Virtual"
                    <div className="ml10">
                      <CustomButton
                        text={`${
                          apntDet?.appointmentType === "Virtual" &&
                          apntDet?.appointmentStatus !== "completed"
                            ? "Join Call"
                            : apntDet?.appointmentType === "Physical"
                              ? apntDet?.appointmentStatus === "scheduled"
                                ? "Check-in"
                                : apntDet?.appointmentStatus === "inprogress"
                                  ? "Call-in"
                                  : apntDet?.appointmentStatus ===
                                      "consultation"
                                    ? "Finalize"
                                    : "Checkout"
                              : //handled home visit btn
                                apntDet?.appointmentType === "Home"
                                ? apntDet?.appointmentStatus === "scheduled"
                                  ? "In Transit"
                                  : apntDet?.appointmentStatus === "intransit"
                                    ? "In Consult"
                                    : apntDet?.appointmentStatus ===
                                        "consultation"
                                      ? "Finalize"
                                      : "Checkout"
                                : ""
                        }`}
                        onClick={() => {
                          apntDet?.appointmentType === "Virtual"
                            ? handleJoinVideoCall()
                            : apntDet?.appointmentType === "Home"
                              ? callHomeBtnApi()
                              : callButtonApi();
                        }}
                        disabled={isCheckoutDisabled}
                        grayBtn={isCheckoutDisabled}
                        smallBtn
                      />
                    </div>
                  ) : null)}
                {apntDet?.inpatient &&
                (apntDet?.appointmentStatus?.toLowerCase() === "scheduled" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "insurgery" ||
                  // (apntDet?.appointmentStatus?.toLowerCase() === "recovery" &&
                  //   !appData?.inpatient?.hospitalization) ||
                  (apntDet?.appointmentStatus?.toLowerCase() === "recovery" &&
                    appData?.inpatient?.hospitalization)) ? (
                  <div className="ml10">
                    <CustomButton
                      text={`${
                        apntDet?.appointmentStatus?.toLowerCase() ===
                        "scheduled"
                          ? "Call-in"
                          : apntDet?.appointmentStatus?.toLowerCase() ===
                              "insurgery"
                            ? "Send To Recovery"
                            : // : apntDet?.appointmentStatus?.toLowerCase() ===
                              //     "recovery" &&
                              //   !appData?.inpatient?.hospitalization
                              // ? "Admit"
                              apntDet?.appointmentStatus?.toLowerCase() ===
                                  "recovery" &&
                                appData?.inpatient?.hospitalization
                              ? "Send To Surgery"
                              : ""
                      }`}
                      onClick={() => {
                        onClickInpatientBtn();
                      }}
                      // disabled={
                      //   apntDet?.appointmentStatus === "finalize" &&
                      //   apntDet?.checkOut !== "Y"
                      // }
                      // grayBtn={
                      //   apntDet?.appointmentStatus === "finalize" &&
                      //   apntDet?.checkOut !== "Y"
                      // }
                      smallBtn
                    />
                  </div>
                ) : null}
              </div>

              <div className="mb10">
                <PetRemindersSidebar
                  onOpenReminders={() => setRemModVsble(true)}
                  apntId={apntId}
                />
              </div>

              <div className="mb3 uppercase clr-muted fs11 txt-semi-bold">
                Shortcuts
              </div>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="flex-row cursor">
                  <div
                    className="p5 br5 flex-start w100Per white-blue-hvr"
                    onClick={handleEditPet}
                  >
                    <Typography className="fs13 blue-color font-medium">
                      Edit Profile
                    </Typography>
                  </div>
                </div>
                <div className="flex-row cursor">
                  <div
                    className="p5 br5 flex-start w100Per white-blue-hvr"
                    onClick={onViewTrends}
                  >
                    <Typography className="fs13 blue-color font-medium">
                      Vital Trends
                    </Typography>
                  </div>
                </div>

                {statusActive ? (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row cursor">
                        <div
                          className="p5 br5 flex-start w100Per white-blue-hvr"
                          onClick={bookAppointment}
                        >
                          <Typography className="fs13 blue-color font-medium">
                            Book an appointment
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row cursor">
                        <div
                          className="p5 br5 flex-start w100Per white-blue-hvr"
                          onClick={onClickSOA}
                        >
                          <Typography className="fs13 blue-color font-medium">
                            SOA
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row cursor">
                        <div
                          className="p5 br5 flex-start w100Per white-blue-hvr"
                          onClick={() => setRemModVsble(true)}
                        >
                          <Typography className="fs13 blue-color font-medium">
                            Reminders
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row cursor">
                        <div
                          className="p5 br5 flex-start w100Per white-blue-hvr"
                          onClick={() => setCertModVsble(true)}
                        >
                          <Typography className="fs13 blue-color font-medium">
                            Certificates
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                  </>
                ) : null}

                {apntDet?.inpatient &&
                appData?.inpatient?.hospitalization &&
                apntDet?.appointmentStatus?.toLowerCase() !== "finalize" &&
                apntDet?.appointmentStatus?.toLowerCase() !== "completed" ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="flex-row cursor" onClick={handleDischarge}>
                      <div className="p5 br5 flex-start w100Per white-blue-hvr">
                        <Typography className="fs13 blue-color font-medium">
                          Discharge Patient
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : (apntDet?.inpatient &&
                    !appData?.inpatient?.hospitalization &&
                    apntDet?.appointmentStatus?.toLowerCase() ===
                      "scheduled") ||
                  apntDet?.appointmentType?.toLowerCase() === "virtual" ||
                  apntDet?.appointmentType?.toLowerCase() === "home" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "finalize" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "completed" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "canceled" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "cancelled" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "pending" ||
                  !apntId ? null : (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div
                      className="flex-row cursor"
                      onClick={() => setAdmitModVisible(true)}
                    >
                      <div className="p5 br5 flex-start w100Per white-blue-hvr">
                        <Typography className="fs13 blue-color font-medium">
                          Admit Patient
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                )}
                {statusActive ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="flex-row cursor">
                      <div
                        className="p5 br5 flex-start w100Per white-blue-hvr"
                        onClick={handleCollectAdvance}
                      >
                        <Typography className="fs13 blue-color font-medium">
                          Collect/Refund
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : null}
              </Grid>

              {/*
              <Grid container className="mb20 mt10">                
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className="mt10"
                >
                  <Typography className="text-bold mb10 fs14">
                    Shortcuts
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="flex-row mv5 cursor">
                    <EditIcon className="lef-icon" />
                    <div className="ml10 flex-center" onClick={handleEditPet}>
                      <Typography className="txt-regular fs14">
                        Edit Profile
                      </Typography>
                    </div>
                  </div>
                </Grid>
                {statusActive ? (
                  <>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row mv5 cursor">
                        <CalendarMonthOutlinedIcon className="lef-icon" />
                        <div
                          className="ml10 flex-center"
                          onClick={bookAppointment}
                        >
                          <Typography className="txt-regular fs14">
                            Book an appointment
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row mv5 cursor">
                        <WorkHistoryIcon className="lef-icon" />
                        <div className="ml10 flex-center" onClick={onClickSOA}>
                          <Typography className="txt-regular fs14">
                            SOA
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row mv5 cursor">
                        <EventAvailableIcon className="lef-icon" />
                        <div
                          className="ml10 flex-center"
                          onClick={() => setRemModVsble(true)}
                        >
                          <Typography className="txt-regular fs14">
                            Reminders
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="flex-row mv5 cursor">
                        <CardMembershipIcon className="lef-icon" />
                        <div
                          className="ml10 flex-center"
                          onClick={() => setCertModVsble(true)}
                        >
                          <Typography className="txt-regular fs14">
                            Certificates
                          </Typography>
                        </div>
                      </div>
                    </Grid>
                  </>
                ) : null}                
                {apntDet?.inpatient &&
                appData?.inpatient?.hospitalization &&
                apntDet?.appointmentStatus?.toLowerCase() !== "finalize" &&
                apntDet?.appointmentStatus?.toLowerCase() !== "completed" ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div
                      className="flex-row mv5 cursor"
                      onClick={handleDischarge}
                    >
                      <BookmarkRemoveIcon className="lef-icon" />
                      <div className="ml10 flex-center">
                        <Typography className="txt-regular fs14">
                          Discharge Patient
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : (apntDet?.inpatient &&
                    !appData?.inpatient?.hospitalization &&
                    apntDet?.appointmentStatus?.toLowerCase() ===
                      "scheduled") ||
                  apntDet?.appointmentType?.toLowerCase() === "virtual" ||
                  apntDet?.appointmentType?.toLowerCase() === "home" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "finalize" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "completed" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "canceled" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "cancelled" ||
                  apntDet?.appointmentStatus?.toLowerCase() === "pending" ||
                  !apntId ? null : (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div
                      className="flex-row mv5 cursor"
                      onClick={() => setAdmitModVisible(true)}
                    >
                      <MedicationIcon className="lef-icon" />
                      <div className="ml10 flex-center">
                        <Typography className="txt-regular fs14">
                          Admit Patient
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                )}
                {statusActive ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="flex-row mv5 cursor">
                      <img
                        src={require("../../../assets/images/png/collectAdvance.png")}
                        className="lef-icon"
                      />
                      <div
                        className="ml10 flex-center"
                        onClick={handleCollectAdvance}
                      >
                        <Typography className="txt-regular fs14">
                          Collect/Refund
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : null}                
              </Grid> */}
            </Container>
          </div>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={upcomingVisible ? 7 : 9.5}
          lg={upcomingVisible ? 7 : 9.5}
          xl={upcomingVisible ? 7 : 9.5}
          className={`${upcomingVisible ? "border-rt" : ""} ${
            scrollable ? "scrollable-content" : ""
          }`}
        >
          {/* <Container maxWidth="xl"> */}
          {children}
          {/* </Container> */}
        </Grid>
        {upcomingVisible ? (
          <Grid
            item
            xs={12}
            sm={12}
            md={2.5}
            lg={2.5}
            xl={2.5}
            className="back-white"
          >
            <div
            // className="scroll-90vh"
            >
              <Grid container className="mv15 ph10">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="shadow-card br8 pt10 pb10 pr15 pl15">
                    <div className="flex-row-between">
                      <div className="flex-row-ali-cen">
                        <Typography className="txt-semi-bold fs11 clr-dark-gray">
                          Active Appointments
                        </Typography>
                        <Typography className="txt-semi-bold fs11 red-color ml3">
                          ({getReqAppointments()?.length ?? 0})
                        </Typography>
                      </div>
                      <Typography
                        className="fs10 font-medium clr-dark-gray cursor underline"
                        onClick={() => setPetApptModVsble(true)}
                      >
                        Show All
                      </Typography>
                    </div>
                  </div>

                  <div className="mt15 shadow-card br8 pt10 pb10 pr15 pl15">
                    <div className="flex-row-between">
                      <Typography className="txt-semi-bold fs11 clr-dark-gray">
                        Internal Tags
                      </Typography>
                      <Typography
                        className="fs10 font-medium clr-dark-gray cursor"
                        onClick={openIntrnalTagModal}
                      >
                        Edit
                      </Typography>
                    </div>
                    {petData?.petInternalTags?.length > 0 && (
                      <div className="flex-row-wrap1">
                        {petData?.petInternalTags?.map((tg) => (
                          <div
                            className="flex-row-ali-cen pv5 ph10 cursor br15 mh5 mv5"
                            style={{ background: tg?.color }}
                            key={tg?.internalId}
                          >
                            <Typography className="font-bold fs10 white-color">
                              {tg?.tags}
                            </Typography>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="mt15 shadow-card br8 pt10 pb10 pr15 pl15">
                    <div className="flex-row-between">
                      <Typography className="txt-semi-bold fs11 clr-dark-gray">
                        Internal Notes
                      </Typography>
                      <Typography
                        className="fs10 font-medium clr-dark-gray cursor"
                        onClick={openIntrnalNotModal}
                      >
                        Edit
                      </Typography>
                    </div>
                    <div className="mt10 ">
                      <Typography className="txt-regular fs11">
                        -----
                      </Typography>
                    </div>
                  </div>

                  <div className="mt15 shadow-card br8 pt10 pb10 pr15 pl15">
                    <div className="flex-row-between">
                      <Typography className="txt-semi-bold fs11 clr-dark-gray">
                        Billing
                      </Typography>
                      <Typography
                        className="fs10 font-medium clr-dark-gray cursor viewBtn"
                        onClick={onViewCustomerSOA}
                      >
                        View
                      </Typography>
                    </div>
                    <div className="mt10">
                      <div>
                        <Typography className="font-bold fs12 red-color">
                          Outstanding:{" "}
                          {(Number(getAllOutstandingBlance()) ?? 0 > 0)
                            ? `Rs ${Number(getAllOutstandingBlance()).toFixed(2)}`
                            : "Nil"}
                        </Typography>
                        <Typography className="mt5 font-bold fs12 green-color">
                          Credits:{" "}
                          {Number(petData?.advanceAmount)
                            ? `Rs ${Number(petData?.advanceAmount).toFixed(2)}`
                            : "Nil"}
                        </Typography>
                      </div>
                    </div>
                  </div>

                  <div className="mt15 shadow-card br8 pt10 pb10 pr15 pl15">
                    <div className="flex-row-between-align-center">
                      <Typography className="txt-semi-bold fs11 clr-dark-gray">
                        Other Pets
                      </Typography>
                      <Typography
                        className="fs20 font-medium clr-dark-gray cursor"
                        onClick={() => setCreatePetModVsble(true)}
                      >
                        +
                      </Typography>
                    </div>
                    <div className="mt10">
                      <Typography className="txt-regular fs11">
                        <div className="flex-row scrollx">
                          {(apntId ? appData : petData)?.otherPets?.length >
                            0 &&
                            (apntId ? appData : petData)?.otherPets
                              ?.filter((pet) => pet?.petId !== petData?.petId)
                              ?.map((pet, i) => (
                                <div
                                  key={i + pet?.petId}
                                  className="mh10 cursor"
                                  onClick={() => handleClickPet(pet)}
                                >
                                  {pet?.petImage ? (
                                    <img
                                      src={pet?.petImage}
                                      alt=""
                                      className="img3 img3mhmw"
                                    />
                                  ) : (
                                    <div className="flex-center h50img">
                                      <Typography className="font-bold fs30 white-color capitalize">
                                        {pet?.petName?.[0]}
                                      </Typography>
                                    </div>
                                  )}
                                  <Custom3dotString
                                    str={pet?.petName}
                                    className="fs12 mt5 txt-semi-bold flex-center gray4"
                                    length={6}
                                  />
                                </div>
                              ))}
                        </div>
                      </Typography>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        ) : null}
        {modalBookVisible ? (
          <BookAnAppointment
            modalVisible={modalBookVisible}
            setBookModVisible={setBookModVisible}
            selectedPet={selectPet}
          />
        ) : null}
        {selectedTab === "overView" ? (
          <>
            <InternalTags
              intrnalTagModVsble={intrnalTagModVsble}
              setIntrnalTagModVsble={setIntrnalTagModVsble}
              updatedApp={apntDet}
              appoinment={appointment}
            />
            <InternalNotes
              intrnalNoteModVsble={intrnalNoteModVsble}
              setIntrnalNoteModVsble={setIntrnalNoteModVsble}
              updatedApp={apntDet}
              appoinment={appointment}
            />

            <Allergies
              allergyModOpen={allergyModOpen}
              setAllergyModOpen={setAllergyModOpen}
              updatedApp={apntDet}
              appointment={appointment}
            />
          </>
        ) : null}
      </Grid>
      {createPetModVsble ? (
        <CreateClinicPet
          createModVisible={createPetModVsble}
          onCloseCreateMod={onCloseCreateMod}
          userDetails={{
            id: apntId ? appData?.pet?.userId : petDetails?.userId,
            email: apntId ? appData?.pet?.userEmail : petDetails?.userEmail,
            name: apntId ? appData?.pet?.userName : petDetails?.userName,
            mobile: apntId ? appData?.pet?.userMobile : petDetails?.userMobile,
          }}
          selectedStep={1}
        />
      ) : null}

      {selectedHistory ? (
        <MedicalHistoryView
          selectedHistory={selectedHistory}
          petData={petData}
          onUploadComplete={(e, apntId) => handleUploadComplete(e, apntId)}
        />
      ) : null}

      <CustomModal
        open={petApptModVsble}
        onClose={() => setPetApptModVsble(false)}
        header={`Active Appointments (${getReqAppointments()?.length ?? 0})`}
        rightModal
        modalWidth={30}
      >
        <div className="scroll-85vh ph15">
          {getReqAppointments()?.map((apnt) => {
            return (
              <div
                className="pat-top-con light-blue-back4 ph10 pv10 w100Per mv10 br10 cursor"
                key={apnt?.appointmentId}
                onClick={() => onClickAppointment(apnt)}
              >
                <div className="flex-row-ali-cen">
                  <Typography className="fs12 blue-color font-bold">
                    Case ID - {apnt?.caseId}
                  </Typography>
                  <Typography className="blue-color fs12 font-medium ml15">
                    {apnt?.serviceType}
                  </Typography>
                  <Typography className="blue-color fs12 font-bold ml15">
                    {moment(new Date(apnt?.appointmentdateTime)).format(
                      "DD MMM YYYY, HH:mm",
                    )}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen mt5">
                  <Typography className="blue-color fs12 txt-semi-bold">
                    {/* {getRightSaluation(clinicVets, apnt?.doctorId)} */}
                    Dr. {apnt?.doctorName}
                  </Typography>
                  <Typography
                    className={`txt-regular white-color fs12 upcom-app-box con-fit ml15 ${
                      apnt?.appointmentType === "Physical"
                        ? "card-con-blue-back"
                        : "virtual-bg-color"
                    }`}
                  >
                    {apnt?.appointmentType}
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
      </CustomModal>

      <CustomModal
        open={soaValues?.visible}
        onClose={onCloseSOAMod}
        header="Statement Of Accounts"
        modal
        modalWidth={soaValues?.dateSelected ? 80 : 30}
        headerBold
      >
        <div className={`${soaValues?.dateSelected ? "scroll-70vh" : ""} ph20`}>
          <div>
            {!soaValues?.dateSelected ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography className="font-medium fs14 black">
                    Start Date
                  </Typography>
                  <CustomTextField
                    mobileDate
                    fullWidth
                    value={soaValues?.startDate}
                    name="startDate"
                    handleChange={(e) =>
                      onChangeSOAValue("startDate", e?.target?.value)
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Typography className="font-medium fs14 black">
                    End Date
                  </Typography>
                  <CustomTextField
                    mobileDate
                    fullWidth
                    value={soaValues?.endDate}
                    name="endDate"
                    handleChange={(e) =>
                      onChangeSOAValue("endDate", e?.target?.value)
                    }
                  />
                </Grid>
                <div className="flex1-end mv20">
                  <div>
                    <CustomButton
                      text="Proceed"
                      smallBtn
                      onClick={onClickProceed}
                    />
                  </div>
                </div>
              </Grid>
            ) : null}
            {soaValues?.dateSelected ? (
              <>
                <ContentToPrint
                  ref={contentToPrint}
                  header={
                    <div className="flex-row-ali-cen mv20">
                      <div className="w35Per">
                        <div>
                          {clinicDet?.image ? (
                            <img
                              src={clinicDet?.image}
                              className="img-h75"
                              alt=""
                            />
                          ) : (
                            <div className="flex-center h50img">
                              <Typography className="font-bold fs30 white-color capitalize">
                                {clinicDet?.name?.[0]}
                              </Typography>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="w30Per flex-center">
                        <div className="font-bold fs20 blue-color">
                          Statement Of Accounts
                        </div>
                      </div>
                      <div className="w35Per flex1-end">
                        <div className="prescription-doc-header-clinic">
                          <div className="font-bold blue-color fs16">
                            {clinicDet?.name ?? ""}
                          </div>
                          <div className="txt-regular fs12 blue-color">
                            {clinicDet?.address ?? ""}
                          </div>
                          {clinicDet?.taxId?.length > 0 ? (
                            <div className="flex-row-ali-cen mt5">
                              <div className="font-bold fs12 blue-color">
                                TAX ID:{" "}
                              </div>
                              <div className="txt-regular fs12 blue-color ml3">
                                {clinicDet?.taxId ?? ""}
                              </div>
                            </div>
                          ) : null}
                          {clinicDet?.mobile?.length > 0 ? (
                            <div className="flex-row-ali-cen mt5">
                              <div className="font-bold fs12 blue-color">
                                Contact:{" "}
                              </div>
                              <div className="txt-regular fs12 blue-color ml3">
                                {clinicDet?.mobile ?? ""}
                              </div>
                            </div>
                          ) : null}
                        </div>
                        ;
                      </div>
                    </div>
                  }
                  footer={
                    <div className="prescription-print-footer-inner mt20">
                      {clinicDet?.footer?.length > 0 ? (
                        <img src={clinicDet?.footer} alt="" />
                      ) : null}
                    </div>
                  }
                >
                  <tr>
                    <td className="prescription-print-tbody-cell">
                      <div className="prescription-print-body-inner">
                        {soaValues?.dateSelected ? (
                          <div>
                            <div className="flex-row-ali-cen">
                              <div className="flex-row-ali-cen">
                                <Typography className="font-bold fs14 gray4">
                                  Pet / Parent Name
                                </Typography>
                                <div className="txt-semi-bold fs14 black capitalize ml10">
                                  {petData?.petName} / {petData?.userName}
                                </div>
                              </div>
                              <div className="flex1-end">
                                <div className="flex-row-ali-cen">
                                  <Typography className="font-bold fs14 gray4">
                                    Date Range
                                  </Typography>
                                  <div className="txt-semi-bold fs14 black capitalize ml10">
                                    {moment(
                                      new Date(soaValues?.startDate),
                                    ).format("DD MMM YYYY")}{" "}
                                    -{" "}
                                    {moment(
                                      new Date(soaValues?.endDate),
                                    ).format("DD MMM YYYY")}
                                  </div>
                                </div>
                              </div>
                            </div>
                            {getSOAList()?.length > 0 ? (
                              <>
                                {/* <div className="flex-center mt10">
                                  <div className="font-bold fs16 blue-color">
                                    INVOICE SUMMARY
                                  </div>
                                </div> */}
                                <div className="thin-line mt10" />
                                <table className="custom-table">
                                  <thead>
                                    <tr>
                                      <th className="w10Per">Tr. Date</th>
                                      <th className="w10Per">Type</th>
                                      <th className="w15Per">Ref. No.</th>
                                      <th className="w10Per">Source</th>
                                      <th className="w13Per">Payment Mode</th>
                                      <th className="w15Per">Debit</th>
                                      <th className="w15Per">Credit</th>
                                      <th className="w12Per">Balance</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {/* {(petBillingList?.data ?? [])?.length ===
                                      0 || !petBillingList?.data ? (
                                      <tr>
                                        <td colSpan={5}>
                                          <div className="flex-center">
                                            No records available
                                          </div>
                                        </td>
                                      </tr>
                                    ) : null} */}
                                    {getSOAList()?.map((bl, i) => {
                                      return (
                                        <tr
                                          key={`${bl?.paymentId ?? bl?.collectionId}_${i}_soa`}
                                        >
                                          <td>
                                            {moment(
                                              new Date(bl?.itemDate),
                                            ).format("DD MMM YYYY")}
                                          </td>
                                          <td>{bl?.itemType ?? ""}</td>
                                          <td>{bl?.refNo ?? ""}</td>
                                          <td></td>
                                          <td></td>
                                          <td>
                                            {Number(bl?.debit)?.toFixed(2)}
                                          </td>
                                          <td>
                                            {Number(bl?.credit)?.toFixed(2)}
                                          </td>
                                          <td>
                                            {Number(bl?.balanceDue)?.toFixed(2)}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                    <tr>
                                      <td colSpan={8} style={{ padding: 0 }}>
                                        <div className="thin-line" />
                                      </td>
                                    </tr>
                                    <tr key="tot">
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td>
                                        <div className="font-bold">Total</div>
                                      </td>
                                      <td>
                                        <div className="font-bold">
                                          {Number(
                                            soaTotals?.totalDebit ?? 0,
                                          )?.toFixed(2)}
                                        </div>
                                      </td>
                                      <td>
                                        <div className="font-bold">
                                          {Number(
                                            soaTotals?.totalCredit ?? 0,
                                          )?.toFixed(2)}
                                        </div>
                                      </td>
                                      <td>
                                        <div className="font-bold">
                                          {Number(
                                            Number(
                                              soaTotals?.totalCredit ?? 0,
                                            ) -
                                              Number(
                                                soaTotals?.totalDebit ?? 0,
                                              ),
                                          )?.toFixed(2)}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div className="thin-line" />
                              </>
                            ) : null}
                          </div>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                </ContentToPrint>
                <div className="flex-end mv20">
                  <div>
                    <CustomButton text="Print" smallBtn onClick={handlePrint} />
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={customerSOAVsble}
        onClose={() => setCustomerSOAVsble(false)}
        header="Statement of Account (due)"
        modal
        modalWidth={30}
        headerBold
      >
        <div className="scroll-80vh-new ph10">
          {getCustomerDueSOA()?.length > 0 ? (
            <>
              {getCustomerDueSOA()?.map((li) => (
                <div key={li?.paymentId}>
                  <div className="flex-row mt5">
                    <div className="w70Per">
                      <div className="fs12 font-medium">
                        {li?.invoiceNumber ?? ""}
                      </div>
                      <div className="fs10 font-medium">
                        {li?.petName ?? ""}
                      </div>
                      <div className="fs10 font-medium">
                        {moment(li?.date).format("DD MMM YYYY")}
                      </div>
                    </div>
                    <div className="w30Per flex1-end">
                      <div className="fs12 font-medium">
                        {Number(li?.balanceDue ?? 0)?.toFixed(2)}
                      </div>
                    </div>
                  </div>
                  <div className="gry-hor-split3" />
                </div>
              ))}
              <div className="blk-hor-split mt5" />
              <Typography className="font-bold fs12 red-color mv5">
                Total due:{" "}
                {`Rs ${Number(getAllOutstandingBlance()).toFixed(2)}`}
              </Typography>
              <div className="blk-hor-split" />
            </>
          ) : (
            <div className="no-rec">No records available</div>
          )}
        </div>
      </CustomModal>

      <CustomModal
        open={remModVsble}
        onClose={onCloseRemMod}
        header="Schedules/Reminders"
        modal
        modalWidth={90}
        headerBold
      >
        <div className="scroll-80vh">
          <div className="rem-mod-tabs-wrap flex-row-ali-cen">
            <div
              className={`rem-mod-tab flex-row-ali-cen cursor ${
                actTab === "preventive"
                  ? "rem-mod-tab-active rem-mod-tab-preventive"
                  : ""
              }`}
              onClick={() => onChangeTab("preventive")}
            >
              <ShieldOutlinedIcon
                sx={{
                  fontSize: 18,
                  color: actTab === "preventive" ? "#1a7a4a" : AppColors.green,
                }}
              />
              <Typography
                className={`fs13 font-bold ml5 ${
                  actTab === "preventive"
                    ? "rem-mod-tab-preventive-text"
                    : "black"
                }`}
              >
                Preventive
              </Typography>
            </div>
            <div
              className={`rem-mod-tab flex-row-ali-cen cursor ${
                actTab === "diagnostics"
                  ? "rem-mod-tab-active rem-mod-tab-diagnostics"
                  : ""
              }`}
              onClick={() => onChangeTab("diagnostics")}
            >
              <BiotechOutlinedIcon
                sx={{
                  fontSize: 18,
                  color: AppColors.appPrimary,
                }}
              />
              <Typography
                className={`fs13 font-bold ml5 ${
                  actTab === "diagnostics"
                    ? "rem-mod-tab-diagnostics-text"
                    : "black"
                }`}
              >
                Diagnostics
              </Typography>
            </div>
            <div
              className={`rem-mod-tab flex-row-ali-cen cursor ${
                actTab === "procedure"
                  ? "rem-mod-tab-active rem-mod-tab-care"
                  : ""
              }`}
              onClick={() => onChangeTab("procedure")}
            >
              <MedicationOutlinedIcon
                sx={{
                  fontSize: 18,
                  color: AppColors.rose,
                }}
              />
              <Typography
                className={`fs13 font-bold ml5 ${
                  actTab === "procedure" ? "rem-mod-tab-care-text" : "black"
                }`}
              >
                Care
              </Typography>
            </div>
            <div className="flex1-end">
              {/* {actTab === "prescription" ? (
                <div className="w25Per">
                  <Select
                    list={presFilters}
                    value={presFilter}
                    handleChange={(e) => setPresFilter(e?.target?.value)}
                    name="petType"
                    select
                  />
                </div>
              ) : null} */}
              <div className="ml10">
                <CustomButton text="Add" onClick={onClickAdd} smallBtn />
              </div>
            </div>
          </div>
          {actTab === "preventive" && (
            <ReminderPreventive addVsble={addVsble} setAddVsble={setAddVsble} />
          )}
          {/* {actTab === "prescription" && (
            <ReminderPrescription
              addVsble={addVsble}
              setAddVsble={setAddVsble}
              presFilter={presFilter}
            />
          )} */}
          {actTab === "diagnostics" && (
            <ReminderDiagnostics
              addVsble={addVsble}
              setAddVsble={setAddVsble}
              apntId={apntId}
            />
          )}
          {actTab === "procedure" && (
            <ReminderProcedure addVsble={addVsble} setAddVsble={setAddVsble} />
          )}
        </div>
      </CustomModal>

      {certModVsble ? (
        <CerificatesDownloadModal
          modVsble={certModVsble}
          onCloseMod={onCloseCertMod}
        />
      ) : null}

      {/* <CustomModal
        open={certModVsble}
        onClose={onCloseCertMod}
        header="Certificates"
        modal
        modalWidth={80}
        headerBold
      >
        <div className="scroll-80vh">
          <div className="flex-row-ali-cen mh20">
            <Typography
              className={`txt-semi-bold fs12 gray4 cursor ${
                actTab === "preventive" ? "tab-grn-back" : "tab-gray-back"
              }`}
              onClick={() => onChangeTab("preventive")}
            >
              Preventive
            </Typography>
          </div>

          <Preventive setScrollable={setScrollable} />
        </div>
      </CustomModal> */}
      {admitModVisible ? (
        <InpatientAdmitPatient
          modalVisible={admitModVisible}
          onCloseMod={onCloseAdmitModal}
          modalData={{
            ...appData?.appointment,
            patientId: appData?.inpatient?.patientId,
          }}
          sendToRecovery={sendToRecovery}
        />
      ) : null}

      {/* <AdmitPatient
        modalVisible={admitModVisible}
        onCloseMod={onCloseAdmitModal}
        modalData={appData?.appointment}
      /> */}

      <CustomModal
        open={coOwnerModalVisible}
        onClose={handleCoOwnModClose}
        header="Co-Owner Details"
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="text-bold fs14 mb5">
              Name <span className="red-color">*</span>
            </div>
            <CustomTextField
              name="name"
              fullWidth
              value={coOwnDetails?.name}
              handleChange={(e) => handleCoOwnChange("name", e?.target?.value)}
              error={coOwnErrors?.name}
              helperText={coOwnErrors?.name ? "Name is required field" : ""}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="mb20">
            <div className="text-bold fs14 mb5">
              Email <span className="red-color">*</span>
            </div>
            <CustomTextField
              name="email"
              fullWidth
              value={coOwnDetails?.email}
              handleChange={(e) => handleCoOwnChange("email", e?.target?.value)}
              error={coOwnErrors?.email}
              helperText={coOwnErrors?.email ? "Email is required field" : ""}
            />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6} className="mb20">
            <div className="text-bold fs14 mb5 ">
              Contact Number <span className="red-color">*</span>
            </div>
            <CustomTextField
              name="mobile"
              fullWidth
              value={coOwnDetails?.mobile}
              handleChange={(e) =>
                handleCoOwnChange("mobile", e?.target?.value)
              }
              error={coOwnErrors?.mobile}
              helperText={coOwnErrors?.mobile ? "Mobile is required field" : ""}
            />
          </Grid>

          <div className="flex1-end">
            <div>
              <CustomButton text="Save" smallBtn onClick={handleSaveCoOwner} />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={disCofrmModVsble}
        onClose={handleCloseDisCnfrm}
        header="Discharge Pet"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to Discharge the patient?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={handleConfirmDischarge}
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={handleCloseDisCnfrm} />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={bundleModVsble}
        onClose={handleBundleclose}
        header={isAddNewBundle ? "Select Bundle" : "Active Bundle"}
        modal
        modalWidth={40}
        addBtn={!isAddNewBundle}
        onClickAdd={handleAddBundle}
      >
        <div className="scroll-60vh">
          {isAddNewBundle ? (
            <CustomTextField
              placeholder="Search"
              fullWidth
              handleChange={(e) => setBundleSearchValue(e.target.value)}
              value={bundleSearchValue}
              backgroundColor={AppColors.lightPink}
            />
          ) : null}
          {(!isAddNewBundle && petTreatmentBundles?.length > 0) ||
          (isAddNewBundle && treatmentBundles?.length > 0) ? (
            (isAddNewBundle
              ? bundleSearchValue?.length > 0
                ? treatmentBundles?.filter((bl) =>
                    bl?.bundleName
                      ?.toLowerCase()
                      ?.includes(bundleSearchValue?.toLowerCase()),
                  )
                : treatmentBundles
              : petTreatmentBundles
            )?.map((li, i) => (
              <div
                key={i}
                className={`mt10 cursor ${
                  (li?.treatmentId ?? li?.bundleId) ===
                  (selectedBundle?.treatmentId ?? selectedBundle?.bundleId)
                    ? "blue-box2"
                    : "gray-box3"
                }`}
                onClick={() => setSelectedBundle(li)}
              >
                <div className="flex-row-between-align-center">
                  <div className="flex-row-ali-cen">
                    <CustomCheckbox
                      circle
                      checked={
                        selectedBundle
                          ? (li?.treatmentId ?? li?.bundleId) ===
                            (selectedBundle?.treatmentId ??
                              selectedBundle?.bundleId)
                          : false
                      }
                    />
                    <Typography className="fs14 blue-color font-bold">
                      {li?.bundleName}
                    </Typography>
                  </div>
                  <Typography className="font-bold fs14 red12">
                    {!isAddNewBundle
                      ? "Remaining Qty: 1"
                      : `Rs ${Number(
                          getTotalEstimatedCost(li?.treatmentBundleDetails),
                        )?.toFixed(2)}`}
                  </Typography>
                </div>
                <div className="flex-row-ali-cen ph10">
                  <div className="gry-dot2" />
                  <Typography className="fs12 blue-color txt-regular ml5">
                    Type:
                  </Typography>
                  <Typography className="fs12 black20 txt-regular ml5">
                    {li?.usageType}
                  </Typography>
                </div>

                <Typography className="gray22 fs14 font-medium ph10">
                  {li?.description}
                </Typography>
              </div>
            ))
          ) : (
            <div className="no-record">No active bundles available</div>
          )}
          {selectedBundle ? (
            <div className="flex-center">
              <div className="mv20">
                <CustomButton smallBtn text="Assign" onClick={handleAssign} />
              </div>
            </div>
          ) : null}
        </div>
      </CustomModal>

      <CustomModal
        open={petModVsble}
        onClose={petModClose}
        header="Update"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20 mt10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mb30">
              <CustomUpload
                uploadText="Profile Picture"
                onUploadFile={onUploadFile}
                value={petValues?.image?.previewUrl}
                profileImg
                imageHeight={140}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Name <span className="red-color">*</span>
              </div> */}
              <div className="mb20">
                <CustomTextField
                  name="petName"
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "petName")
                  }
                  value={petValues?.petName}
                  error={!!errors.petName}
                  helperText={errors.petName}
                  label="Name "
                  required={true}
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Pet Type <span className="red-color">*</span>
              </div> */}
              <div className="mb20">
                <Select
                  list={petTypeList}
                  value={petValues?.petType}
                  handleChange={(e, value) =>
                    handlePetValueChange(value, "petType")
                  }
                  name="petType"
                  search
                  error={!!errors.petType}
                  helperText={errors.petType}
                  label="Pet Type *"
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Age in {petValues?.ageType} <span className="red-color">*</span>
              </div> */}
              <div className="mb20">
                <CustomTextField
                  name="dob"
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "dob")
                  }
                  value={petValues?.dob}
                  error={!!errors.dob}
                  helperText={errors.dob}
                  label="Age "
                  required={true}
                  type="number"
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Age Type <span className="red-color">*</span>
              </div> */}
              <div className="mb20">
                <Select
                  list={[
                    { name: "Month", value: "Month" },
                    { name: "Year", value: "Year" },
                  ]}
                  value={petValues?.ageType}
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "ageType")
                  }
                  name="ageType"
                  select
                  error={!!errors.ageType}
                  helperText={errors.ageType}
                  label="Age Type * "
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Breed <span className="red-color">*</span>
              </div> */}
              <div className="mb20">
                <Select
                  list={breedList}
                  value={petValues?.breed}
                  handleChange={(e, value) =>
                    handlePetValueChange(value, "breed")
                  }
                  name="breed"
                  search
                  error={!!errors.breed}
                  helperText={errors.breed}
                  label="Breed * "
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <CustomTextField
                  label="Color"
                  name="color"
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "color")
                  }
                  value={petValues?.color}
                  error={!!errors.color}
                  helperText={errors.color}
                />
              </div>
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Gender
              </div> */}
              <div className="mb20">
                <Select
                  list={genderList}
                  value={petValues?.gender}
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "gender")
                  }
                  select
                  error={!!errors.gender}
                  helperText={errors.gender}
                  label="Gender * "
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">
                Reproductive Status

              </div> */}
              <div className="mb20">
                <Select
                  list={
                    petValues?.gender?.toLowerCase() === "male"
                      ? reproductiveStatusMaleList
                      : petValues?.gender?.toLowerCase() === "female"
                        ? reproductiveStatusFemaleList
                        : reproductiveStatusUnknownList
                  }
                  value={petValues?.reproductiveStatus}
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "reproductiveStatus")
                  }
                  error={!!errors.reproductiveStatus}
                  helperText={errors.reproductiveStatus}
                  select
                  label="Reproductive Status "
                />
              </div>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <CustomTextField
                  name="weight"
                  value={petValues?.weight}
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "weight")
                  }
                  error={!!errors.weight}
                  helperText={errors.weight}
                  suffix={petValues?.weight !== "" ? "Kg" : ""}
                  label="Weight "
                  // mandatoryField
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <CustomTextField
                  label="Microchip Number"
                  name="rfid"
                  fullWidth
                  handleChange={(e) =>
                    handlePetValueChange(e?.target?.value, "rfid")
                  }
                  value={petValues?.rfid}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">Blood Group</div> */}
              <div className="mb20">
                <Select
                  list={bloodGroups}
                  value={petValues?.bloodGroup}
                  handleChange={(e, value) =>
                    handlePetValueChange(value, "bloodGroup")
                  }
                  name="bloodGroup"
                  error={!!errors.bloodGroup}
                  helperText={errors.bloodGroup}
                  search
                  label="Blood Group "
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              {/* <div className="txt-mont fs14">Temperament</div> */}
              <div className="mb20">
                <Select
                  list={temperaments}
                  value={petValues?.temperament}
                  handleChange={(e, value) =>
                    handlePetValueChange(value, "temperament")
                  }
                  name="temperament"
                  label="Temperament"
                  error={!!errors.temperament}
                  helperText={errors.temperament}
                  search
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end">
                <div>
                  <CustomButton text="Update" onClick={updatePet} smallBtn />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={usrModVsble}
        onClose={usrModClose}
        header="Update"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh-new ph20 mt10">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mt10">
                <CustomTextField
                  label="Parent Name"
                  name="userName"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "userName")
                  }
                  value={usrValues?.userName}
                  error={!!usrErrs.userName}
                  helperText={usrErrs.userName}
                  required={true}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div>
                <CustomTextField
                  label="Contact Number"
                  name="userMobile"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "userMobile")
                  }
                  value={usrValues?.userMobile}
                  error={!!usrErrs.userMobile}
                  helperText={usrErrs.userMobile}
                />
              </div>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div>
                <CustomTextField
                  label="Email"
                  name="email"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "email")
                  }
                  value={usrValues?.email}
                  error={!!usrErrs.email}
                  helperText={usrErrs.email}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div>
                <CustomTextField
                  label="Secondary Phone Number"
                  name="secondaryMobile"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "secondaryMobile")
                  }
                  value={usrValues?.secondaryMobile}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div>
                <CustomTextField
                  label="Address"
                  name="address"
                  fullWidth
                  handleChange={(e) =>
                    handleValueChange(e?.target?.value, "address")
                  }
                  value={usrValues?.address}
                  labelTop
                  multiline
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end">
                <div>
                  <CustomButton text="Update" onClick={updateUser} smallBtn />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={advancePayVsble}
        onClose={handleClosePayMod}
        header="Pay"
        rightModal
        modalWidth={30}
      >
        <div className="flex-center">
          <Card
            sx={{
              borderRadius: 1,
              padding: 2,
              borderTopColor: `${getBorderColor("paid")}`,
            }}
            className="pay-card"
          >
            <div className="maint">
              <div>
                <div className="flex-row parentcontainer">
                  <div className="flex-row  iconcontainer">
                    <AccountCircleOutlinedIcon sx={{ width: 25, height: 25 }} />
                    <Typography className="  font-bold fs14 capitalize flex-center h35">
                      {petData?.userName}
                    </Typography>
                  </div>
                </div>

                <div className="datecontainer"></div>
              </div>
            </div>
          </Card>
        </div>
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-row-ali-cen">
              <Typography className="font-medium fs14 green-color mt15">
                Available Balance:{" "}
                {Number(petData?.advanceAmount)
                  ? `Rs ${Number(petData?.advanceAmount).toFixed(2)}`
                  : "Nil"}
              </Typography>
              <div className="ml10"></div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-row-ali-cen">
              <Typography className="font-medium fs14 black mb5">
                Credit Balance:
              </Typography>
              <div className="ml10">
                <CustomCheckbox
                  radio
                  value={usrValues?.paymentType}
                  onChange={(e) =>
                    handleValueChange(e?.target?.value, "paymentType")
                  }
                  radios={radioPaymentTypes}
                  defaultValue={usrValues?.paymentType}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <div className="mb20">
              <CustomTextField
                label="Amount"
                name="advanceAmount"
                fullWidth
                handleChange={(e) =>
                  handleValueChange(e?.target?.value, "advanceAmount")
                }
                value={usrValues?.advanceAmount}
                error={!!usrErrs.advanceAmount}
                helperText={usrErrs.advanceAmount}
                type="number"
              />
            </div>
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            {/* <div className="font-medium fs14 black2">Payment Mode</div> */}
            <div className="mb20">
              {/* <Select
                list={UserPaymentTypeList}
                value={usrValues?.paymentMode}
                handleChange={(e, value) =>
                  handleValueChange(value, "paymentMode")
                }
                name="paymentMode"
                error={!!usrErrs.paymentMode}
                helperText={usrErrs.paymentMode}
                search
                label="Payment Mode"
              /> */}
              <PaymentModeDropdown
                list={UserPaymentTypeList}
                value={usrValues?.paymentMode}
                onChange={(e) => handleValueChange(e, "paymentMode")}
                hideAdvancedAdjustment={
                  usrValues?.paymentType?.toLocaleLowerCase() === "collect"
                }
              />
            </div>
          </Grid>

          <div className="flex1-end mt20">
            <div>
              <CustomButton text="Pay" onClick={handlePay} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={assignVetModVisible}
        onClose={onCloseAssignVetMod}
        header={
          clinicDetails?.id === apntDet?.doctorId &&
          !checkIsVet(profile?.id) &&
          !apntDet?.facilityId
            ? "Select Vet and Facility"
            : !apntDet?.facilityId
              ? "Select Facility"
              : "Select Vet"
        }
        modal
        modalWidth={30}
      >
        <div className="mh10">
          {clinicDetails?.id === apntDet?.doctorId &&
          !checkIsVet(profile?.id) ? (
            <div>
              <Select
                list={
                  apntDet?.serviceType === "Grooming" ||
                  apntDet?.serviceType === "Lab Tests" ||
                  apntDet?.serviceType === "Radiology Tests"
                    ? getOthersByType(apntDet?.serviceType)
                    : apntDet?.serviceType === "Others"
                      ? getAllClinicUserList()
                      : getVetList()
                }
                handleChange={(e, value) =>
                  onAssignVetChange("vet", value, "error")
                }
                name="vet"
                label="Vet Name *"
                search
                value={assignVetvalues?.vet}
                error={!!assignVetvalues?.error}
                helperText={
                  assignVetvalues?.error ? "Vet Name is required field" : ""
                }
              />
            </div>
          ) : null}
          {!apntDet?.facilityId ? (
            <div
              className={
                clinicDetails?.id === apntDet?.doctorId &&
                !checkIsVet(apntDet?.doctorId) &&
                !checkIsVet(profile?.id)
                  ? "mt15"
                  : ""
              }
            >
              <Select
                list={getFacilitiesByType(apntDet?.serviceType)}
                handleChange={(e, value) =>
                  onAssignVetChange("facility", value, "facilityErr")
                }
                name="facility"
                label="Facility *"
                search
                value={assignVetvalues?.facility}
                error={!!assignVetvalues?.facilityErr}
                helperText={
                  assignVetvalues?.facilityErr
                    ? "Facility is required field"
                    : ""
                }
              />
            </div>
          ) : null}
          <div className="flex-center mv20">
            <div>
              <CustomButton text="Save" onClick={onAssignVet} smallBtn />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={viewTreadsVsble}
        onClose={() => setViewTreadsVsble(false)}
        header="Vital Trends"
        modal
        modalWidth={80}
      >
        <Box sx={{ px: 2.5, pb: 2.5 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            flexWrap="wrap"
            gap={1.5}
          >
            <Typography
              variant="subtitle1"
              fontWeight={600}
              sx={{ color: "#2C2C49" }}
            >
              {selectedVitalTab} Trend
            </Typography>
            <ToggleButtonGroup
              value={selectedVitalTab}
              exclusive
              onChange={(_, val) => val && setSelectedVitalTab(val)}
              size="small"
              sx={{
                backgroundColor: "#f0f2f5",
                borderRadius: "12px",
                "& .MuiToggleButtonGroup-grouped": {
                  borderRadius: "7px",
                  borderColor: "transparent",
                  color: "#333",
                  transition: "none",
                  textTransform: "none",
                  px: 2,
                  "&.Mui-selected": {
                    backgroundColor: "#005EB8",
                    color: "#fff",
                  },
                },
              }}
            >
              {vitalTrendTabs.map((tab) => (
                <ToggleButton key={tab} value={tab}>
                  {tab}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
          <Box
            sx={{
              backgroundColor: "#FAFBFC",
              borderRadius: "8px",
              padding: "16px",
              border: "1px solid #E9ECEF",
              minHeight: 320,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {vitalTrendChartData?.length > 0 ? (
              <Box sx={{ width: "100%" }}>
                <Chart
                  key={selectedVitalTab}
                  options={vitalTrendChartOptions}
                  series={vitalTrendChartSeries}
                  type="line"
                  height={350}
                />
              </Box>
            ) : (
              <Typography
                sx={{
                  color: "#636363",
                  fontSize: "14px",
                  fontWeight: 500,
                  fontFamily: "Montserrat",
                }}
              >
                No records available
              </Typography>
            )}
          </Box>
        </Box>
      </CustomModal>
    </>
  );
};

export default CommonClinicPetDetails;
